import { EventEmitter, Injectable } from '@angular/core';
import { PickupFacade } from '@checkout/data-access';
import { ShopListFacade } from '@shop/data-access';
import { switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PickupService {
  activeShopId$ = this.pickupFacade.getActiveShopId();
  activeShop$ = this.pickupFacade.getActiveShopId().pipe(switchMap((id: string) => this.shopListFacade.getShop(id)));

  setShopEvent = new EventEmitter<string>();

  constructor(
    private pickupFacade: PickupFacade,
    private shopListFacade: ShopListFacade,
  ) {}

  setShop(id: string): void {
    this.pickupFacade.setShop(id);
    this.setShopEvent.emit(id);
  }

  resetShop(): void {
    this.pickupFacade.resetShop();
  }
}
